import { render, staticRenderFns } from "./PayrollAnalyticsChart.vue?vue&type=template&id=0f37e546&scoped=true&"
import script from "./PayrollAnalyticsChart.vue?vue&type=script&lang=js&"
export * from "./PayrollAnalyticsChart.vue?vue&type=script&lang=js&"
import style0 from "./PayrollAnalyticsChart.vue?vue&type=style&index=0&id=0f37e546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37e546",
  null
  
)

export default component.exports